const instudion = [
    { value: "School", label: "School" },
  { value: "College", label: "College" },
  { value: "Coching", label: "Coching" },
]

  export default instudion;